import { CapoPlugin } from "/Users/shichengyi/private/github/letter-to-pabo/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];